import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './AgePicker.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import ArrowUpIcon from 'assets/icons/enter.svg';
import Plus from 'assets/icons/add.svg';
import Minus from 'assets/icons/remove.svg';

class AgePicker extends Component {
  static propTypes = {
    /** Age */
    defaultValue: PropTypes.number,
    /** Submit Age */
    onSubmit: PropTypes.func,
    /** isRTL */
    rtl: PropTypes.bool,
  };

  static defaultProps = {
    defaultValue: 35,
    onSubmit: () => {},
    rtl: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      age: this.props.defaultValue,
    };
  }

  onAgeUp = () => {
    this.setState(prevState => ({
      age: prevState.age + 1,
    }));
  }

  onAgeDown = () => {
    if (this.state.age > 15) {
      this.setState(prevState => ({
        age: prevState.age - 1,
      }));
    }
  }

  handleAgeSubmit = () => {
    this.props.onSubmit(`${this.state.age}`, 'age');
  }

  onAgeInputChange = (evt) => {
    let val = evt.target.value;

    /** limit to 2 digits */
    if (val.length > 2) val = val.slice(0, 2);

    // if (val < 15) console.log('less than 18');

    this.setState({ age: Number(val) });
  }


  render() {
    const classes = classNames({
      'chat-footer': true,
      'chat-footer--rtl': this.props.rtl,
    });
    return (
      <div className={classes}>

        <div className="nw-fieldset nw-fieldset--age-picker">
          <button type="button" className="nw-button nw-button--icon" onClick={this.onAgeDown}>
            <img src={Minus} alt="minus" />
          </button>
          <div className={`nw-fieldset__group nw-fieldset__group--picker ${this.state.age < 15 ? 'invalid' : ''}`}>
            <input
              type="number"
              value={this.state.age}
              onChange={this.onAgeInputChange}
              ref={(age) => { this.customerAge = age; }}
            />
            <button type="button" className="btn-year" onClick={() => { this.customerAge.focus(); }}>
              {/* {this.state.age <= 1 && (<span><FormattedMessage id="year" /></span>)} */}
              <FormattedMessage id="years" />
            </button>
          </div>
          <button
            type="button"
            className="nw-button nw-button--icon"
            onClick={this.onAgeUp}
          >
            {/* <span>+</span> */}
            <img src={Plus} alt="add" />
          </button>
        </div>

        <button type="button" disabled={this.state.age < 18} className="nw-button nw-button--icon nw-button--submit" onClick={this.handleAgeSubmit}>
          <img src={ArrowUpIcon} alt="Submit" />
        </button>
      </div>
    );
  }
}


export default injectIntl(AgePicker);
